import { Languages } from '@wicadu/langscope'

import { type Page } from '@config/pages/const'
import { enPages } from '@config/pages/en'
import { esPages } from '@config/pages/es'
import { frPages } from '@config/pages/fr'
import { PagesId } from '@ts-enums/PagesId'

/**
 * Finds a page in the given pages array by its pageId.
 * @param pageId - The pageId to find.
 * @returns The page object if found, otherwise throws an error.
 */

export function resolvePagePath(pageId: PagesId, lang: Languages): Page {
  const pagesMap: Record<Languages, Page[]> = {
    es: esPages,
    en: enPages,
    fr: frPages,
    pt: [],
    de: [],
    it: [],
  }

  return (pagesMap[lang] || [])?.find((page) => page?.pageId === pageId) as Page
}
